module.exports = __webpack_public_path__ + "img/submit.37200363.svg";